export default "__VITE_PUBLIC_ASSET__f7edf47f__"